import http from '../_httpHandlers';
import { config } from '../_config';
import { IComponent, IComponentService, IInstallServices, IServices } from '../_types/interfaces';

const uri = config.backendAddress;

const getAddress = async (): Promise<string> => {
    return await http.get(`${uri}/ServerAddress`, "text");
};

const getServices = async (uriService: string): Promise<Array<IComponentService>> => {
    return await http.get(`${uriService}/GetServices`);
};


const getInstallServices = async (): Promise<Array<IComponentService>> => {
    return await http.get(`${uri}/GetInstallService`);
};

const getPlugins = async (uriService: string): Promise<Array<IComponentService>> => {
    return await http.get(`${uriService}/GetPlugins`);
};

const getInstallPlugins = async (): Promise<Array<IComponentService>> => {
    return await http.get(`${uri}/GetInstallPlugin`);
};

const addServices = async (services: Array<string>): Promise<void> => {
    return await http.post(`${uri}/AddComponents`, services, 'none');
};

const deleteServices = async (services: Array<string>): Promise<void> => {
    return await http.post(`${uri}/DeleteComponents`, services, 'none');
};

const getUpdateServices = async (): Promise<IServices> => {
    return await http.get(`${uri}/updates`);
};

const updateServices = async (services: IInstallServices): Promise<void> => {
    return await http.post(`${uri}/updates`, services);
};

const requestDownloadService = async (): Promise<void> => {
    return await http.get(`${uri}/CallDownloadService`, 'none');
};

const checkDownloadLoadStatus = async (): Promise<boolean> => {
    return await http.get(`${uri}/CheckDownloadLoadStatus`);
};

const checkUpdateLoadStatus = async (): Promise<boolean> => {
    return await http.get(`${uri}/CheckUpdateLoadStatus`);
};


export const componentService: IComponent = {
    getAddress,
    getServices,
    getPlugins,
    getInstallServices,
    getInstallPlugins,
    addServices,
    deleteServices,
    getUpdateServices,
    requestDownloadService,
    updateServices,
    checkDownloadLoadStatus,
    checkUpdateLoadStatus,
};